import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { simplify } from '../../../shared/functions/meta.functions';

export function applyRequest(lastRequest, searchRequestTemplate) {
  if (!lastRequest) {
    return searchRequestTemplate;
  }
  const searchRequest = searchRequestTemplate;
  for (const key in lastRequest) {
    if (lastRequest.hasOwnProperty(key) && searchRequest.hasOwnProperty(key)) {
      if (lastRequest[key] instanceof Object && searchRequestTemplate[key] instanceof Object) {
        searchRequest[key] = applyRequest(lastRequest[key], searchRequest[key]);
      } else {
        searchRequest[key] = lastRequest[key];
      }
    }
  }
  return searchRequest;
}

export function submit(form: NgForm, request, router: Router, route: ActivatedRoute) {
  if (form.invalid) {
    return;
  }
  markFormAsTouched(form);
  router.navigate(['./list'], {
    relativeTo: route,
    queryParams: { request: JSON.stringify(simplify(request)) }
  });
}

export function markFormAsTouched(form: NgForm) {
  for (const control of Object.values(form.controls)) {
    control.markAsTouched();
  }
}
